import React from 'react'
import { withStyles, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';

const style = theme => ({
	root: {

	}
})

function CancelButton({
	classes,
	onClick,
	className
}) {
	return (
		<Button
			fullWidth
			className={className}
			variant='contained'
			onClick={onClick}
			color='primary'
		>
			{Tr('cancel')}
		</Button>
	)
}

CancelButton.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.any,
	onClick: PropTypes.func,
}

CancelButton.defaultProps = {
}

export default withStyles(style)(CancelButton);